import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/guzellik-merkezlerinin-botoks-yapma-yetkisi-yasal-durum-ve-klinik-gercekler/page.tsx");
